<template>
  <div>
    <v-layout wrap justify-end :style="{ margin: '-4px' }">
      <v-flex shrink class="pa-1">
        <v-btn outline color="grey" class="ma-0" @click="exportData">
          <v-icon>ios_share</v-icon>
          {{ $t('export') }}
        </v-btn>
      </v-flex>
      <v-flex shrink class="pa-1">
        <v-btn
          color="primary"
          class="ma-0"
          @click="isAdvancedSearchVisible = !isAdvancedSearchVisible"
        >
          <v-icon>search</v-icon>
          {{ $t('advanced search') }}
          <v-icon>{{
            isAdvancedSearchVisible ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
          }}</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>

    <AdvancedSearch
      v-if="isAdvancedSearchVisible"
      v-model="filters"
      class="mt-2"
      @input="isAdvancedSearchVisible = false"
    />

    <DataTable
      :items="items"
      :total="total"
      :pagination="{ rowsPerPage: filters.limit, page: filters.page }"
      class="mt-3"
      @update:pagination="handlePaginationUpdate"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
import * as XLSX from 'xlsx'
import { handleApiError } from '@/api/util'
import beaconApi from '@/api/beacon'
import AdvancedSearch from './AdvancedSearch'
import DataTable from './DataTable'

export default {
  components: {
    AdvancedSearch,
    DataTable
  },
  data() {
    return {
      filters: {
        date_from: dayjs().format('YYYY-MM-DD'),
        date_to: dayjs().format('YYYY-MM-DD'),
        limit: 10,
        page: 1
      },
      isAdvancedSearchVisible: false,
      items: [],
      total: 0
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    filters() {
      this.fetch()
    }
  },
  methods: {
    async fetch() {
      try {
        this.$store.dispatch('loading')

        const response = await this.getData()

        if (response.status === 200) {
          this.items = response.data.data
          this.total = response.data.total
        }
      } catch (error) {
        handleApiError(error)
      } finally {
        this.$store.dispatch('loading')
      }
    },
    getData(filters) {
      const { page, tags = [], beacon_id_list = [], ...rest } = this.filters

      return beaconApi.getAnalyticsCustomerTransaction({
        config: {
          pageid: this.selectedBot.pageid,
          data: {
            ...rest,
            tags: tags.join(','),
            beacon_id_list: beacon_id_list.join(','),
            offset: (page - 1) * rest.limit,
            excluded_conversation: '{default}',
            ...filters
          }
        }
      })
    },
    async exportData() {
      try {
        this.$store.dispatch('loading')

        const response = await this.getData({
          offset: 0,
          limit: this.total
        })

        if (response.status === 200) {
          const rows = response.data.data.map((item) => ({
            'User ID': item.user_id || '-',
            'Social Name': item.line_name || '-',
            'Date & Time': item.timestamp ? dayjs(item.timestamp).format('DD/MM/YYYY HH:mm') : '-',
            'Beacon ID': item.beacon_id || '-',
            'Beacon Name': item.beacon_name || '-',
            'Beacon Conversation': item.beacon_conversation || '-',
            'Beacon Message': item.beacon_conversation_answer
              ? item.beacon_conversation_answer.length > 32767
                ? item.beacon_conversation_answer.substring(0, 32766) + '…'
                : item.beacon_conversation_answer
              : '-',
            'Tag(s)': item.beacon_conversation_user_tags || '-'
          }))

          const workBook = XLSX.utils.book_new()
          const workSheet = XLSX.utils.json_to_sheet(rows)
          XLSX.utils.book_append_sheet(workBook, workSheet, 'Customers')
          XLSX.writeFile(workBook, 'beacon-customers.xlsx')
        }
      } catch (error) {
        handleApiError(error)
      } finally {
        this.$store.dispatch('loading')
      }
    },
    handlePaginationUpdate({ page, rowsPerPage }) {
      this.filters = {
        ...this.filters,
        limit: rowsPerPage,
        page
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/Beacon/AnalyticsV2/Customer/index.vue